import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DigitalDownloadService } from 'src/app/common-myaccount-service/digital-download.service';
import { ResourceService } from 'src/app/common-cms-service/resource.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PaypalService } from 'src/app/services/paypal.service';


export interface DigitalDownload {

    id: number;
    name: string;
    slug: string;
    title: string;
    short_description: string;
    description: string;
    thumbnail: string;
    resource_link: string;
    resource_type: string;
    price: number;
    is_active: number;

}

@Component({
  selector: 'app-digital-download-details',
  imports: [
    RouterModule,
    CommonModule,
    FormsModule
  ],
  templateUrl: './digital-download-details.component.html',
  styleUrl: './digital-download-details.component.css',
})
export class DigitalDownloadDetailsComponent {

loading = true;
resource!: DigitalDownload;
resources: DigitalDownload[] = [];
relatedResources: DigitalDownload[] = [];
selectedResource: DigitalDownload | null = null;
showModal = false;
activeTab: 'purchase' | 'existing' = 'purchase';
isProcessingPayment = false;
paymentCompleted = false;
downloadUrl = '';
orderId = '';
lookupEmail = '';
purchaseFound = false;
purchaseChecked = false;

showPaymentSection = false;

  constructor(
      private route: ActivatedRoute,
      private digitalDownloadService: DigitalDownloadService,
      private ResourceService: ResourceService,
      private paypalService: PaypalService
    ) {}



  formData = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    consent: false,
  };

  formErrors: Record<string, string> = {
    firstName: '',
    lastName: '',
    email: '',
  };




 ngOnInit(): void {

    this.route.paramMap.subscribe(params => {

        const slug = params.get('slug');

        if (slug) {

            this.loadResource(slug);

        }

    });

}

   openPurchaseModal(
    resource: DigitalDownload
  ): void {
    this.selectedResource = resource;
    this.activeTab = 'purchase';
    this.showModal = true;
    this.paymentCompleted = false;
    this.purchaseFound = false;
    this.purchaseChecked = false;
    this.lookupEmail = '';
    this.downloadUrl = '';
    this.resetForm();
    document.body.style.overflow =
      'hidden';
  }
  
  
  loadResource(slug: string): void {

    this.loading = true;

    this.ResourceService

        .getResource(slug)

        .subscribe({

            next: (response: any) => {

                this.resource = response.data;

                this.selectedResource = response.data;

                this.loading = false;

                this.loadRelatedResources(slug);

            },

            error: err => {

                console.error(err);

                this.loading = false;

            }

        });

}



loadRelatedResources(slug: string): void {

    this.ResourceService

        .getResources()

        .subscribe({

            next: (response: any) => {

                this.resources = response.data || [];

                this.relatedResources = this.resources

                    .filter(x =>

                        x.slug !== slug &&

                        x.resource_type === this.resource.resource_type

                    )

                    .slice(0, 4);

            }

        });

}





  closeModal(): void {
    this.showModal = false;
    this.selectedResource = null;
    document.body.style.overflow = '';
  }


  resetForm(): void {

    this.formData = {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      consent: false,
    };

    this.formErrors = {
      firstName: '',
      lastName: '',
      email: '',
    };

  }



   clearError(field: string): void {

    this.formErrors[field] = '';

  }

  validateForm(): boolean {

    let valid = true;

    this.formErrors = {

      firstName: '',

      lastName: '',

      email: '',

    };

    if (!this.formData.firstName.trim()) {

      this.formErrors.firstName =
        'First name is required';

      valid = false;

    }

    if (!this.formData.lastName.trim()) {

      this.formErrors.lastName =
        'Last name is required';

      valid = false;

    }

    if (!this.formData.email.trim()) {

      this.formErrors.email =
        'Email address is required';

      valid = false;

    } else if (
      !this.isValidEmail(
        this.formData.email
      )
    ) {

      this.formErrors.email =
        'Please enter a valid email address';

      valid = false;

    }

    return valid;

  }

  isValidEmail(
    email: string
  ): boolean {

    const re =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return re.test(email);

  }

//   createOrder(): void {

//     if (!this.validateForm()) {
//       return;
//     }

//     if (!this.selectedResource) {
//       return;
//     }

//     this.isProcessingPayment = true;

//     const payload = {
//     first_name: this.formData.firstName,
//     last_name: this.formData.lastName,
//     email: this.formData.email,
//     phone: this.formData.phone,
//     consent: this.formData.consent ? 1 : 0,
//     resource_id: this.selectedResource.id
//   };

//     console.log(
//       'Create Order Payload',
//       payload
//     );

//     /**
//      * ===================================================
//      * ACTUAL IMPLEMENTATION LATER
//      * ===================================================
//      */

//     this.digitalDownloadService
//   .createOrder(payload)
//   .subscribe({

//     next: (response) => {

//       this.isProcessingPayment = false;

//       if (response?.data?.paypal_order_id) {

//     this.paypalOrderId =
//       response.data.paypal_order_id;

//     this.orderId =
//       response.data.order_id;

//     this.showPaymentSection = true;

//     // Render PayPal Checkout
//     this.initializePaypal();

// }

//     },

//     error: (error) => {

//       this.isProcessingPayment = false;

//       console.error(error);

//       alert(
//         'Unable to create payment order.'
//       );

//     }

//   });

//   }


continueToPayment(): void {

  if (!this.validateForm()) {
    return;
  }

  if (!this.selectedResource) {
    return;
  }

  this.showPaymentSection = true;

  setTimeout(() => {

    this.initializePaypal();

  });

}


async initializePaypal(): Promise<void> {

  try {

    await this.paypalService.loadSdk();

    const paypal = this.paypalService.getPaypal();

    paypal.Buttons({

      createOrder: () => {

        return new Promise((resolve, reject) => {

          const payload = {

            first_name: this.formData.firstName,
            last_name: this.formData.lastName,
            email: this.formData.email,
            phone: this.formData.phone,
            consent: this.formData.consent ? 1 : 0,
            resource_id: this.selectedResource!.id

          };

          this.digitalDownloadService
            .createOrder(payload)
            .subscribe({

              next: (response) => {

                this.orderId = response.data.order_id;

                resolve(response.data.paypal_order_id);

              },

              error: () => {

                reject();

              }

            });

        });

      },

      onApprove: (data: any) => {
        return new Promise((resolve, reject) => {
          this.digitalDownloadService
            .captureOrder({
              paypal_order_id: data.orderID
            })
            .subscribe({
              next: (response: any) => {
                this.paymentSuccess(
                  response.data.order_id,
                  response.data.download_url
                );
                resolve(true);
              },
              error: () => {
                reject();
              }
            });
        });
      },

      onError: (err: any) => {

        console.error(err);

        alert('Payment failed.');

      }

    }).render('#paypal-button-container');

  } catch (e) {

    console.error(e);

  }

}



  paymentSuccess(
    orderId: string,
    downloadUrl: string
) {

    this.orderId = orderId;

    this.downloadUrl = downloadUrl;

    this.paymentCompleted = true;

}


  checkPurchase(): void {

  if (!this.lookupEmail || !this.selectedResource) {
    return;
  }

  this.purchaseChecked = false;
  this.purchaseFound = false;

  this.digitalDownloadService
    .checkPurchase({
      email: this.lookupEmail,
      resource_id: this.selectedResource.id
    })
    .subscribe({

      next: (response: any) => {

        console.log('Check Purchase Response:', response);

        this.purchaseChecked = true;

        if (response?.data?.purchased) {

          this.purchaseFound = true;

          this.downloadUrl = response.data.download_url;

          this.orderId = response.data.order_id;

        } else {

          this.purchaseFound = false;

          this.downloadUrl = '';

          this.orderId = '';

        }

      },

      error: (error) => {

        console.error('Check Purchase Error:', error);

        this.purchaseChecked = true;

        this.purchaseFound = false;

      }

    });

}


  trackDownload(): void {

  if (!this.orderId) {
    return;
  }

  this.digitalDownloadService
    .trackDownload({

      order_id: this.orderId

    })
    .subscribe();
this.closeModal();
  }


  downloadFreeResource(): void {

    if (!this.resource) {

        return;

    }

    window.open(

        this.resource.resource_link,

        '_blank'

    );

}




}
